/**
 * Profil menüsünün KANONİK öğe kaydı (CLOS-104 `[065]`).
 *
 * ### Neden bir kayıt
 *
 * `[057]`'nin gezinme kaydıyla aynı gerekçe: menü öğeleri bileşenin içine serpiştirilseydi
 * "bu menüde ne var?" sorusunun cevabı JSX'in içinde kaybolur ve kartın NEGATİF kriterini
 * (*"Organizasyon Yönetimi, Abonelik ve Müvekkil Alanı yönetimi Profil menüsüne
 * taşınmaz"*) test etmek imkânsız olurdu. Kayıt tek yerde durunca ihlal ölçülebilir.
 *
 * ### ⚠ Yetki BURAYA GİRMİYOR — bilerek
 *
 * `visibleProfileMenuItems` bir permission parametresi ALMIYOR. Kartın çalışma zamanı
 * koşulu: *"Organizasyon yönetimi veya abonelik permission'ları menüye yeni yönetim öğesi
 * eklemez."* Fonksiyon yetkiyi hiç görmediği için bu yapısal olarak imkânsız; bir bayrak
 * eklenseydi kural bir gün gevşetilebilirdi.
 *
 * ### `route: null` → öğe ÇİZİLMEZ
 *
 * Hedef sayfası olmayan bağlantı, kullanıcıyı hiçbir yere götürmeyen bir satırdır
 * (ADR-0014, `[057]` ile aynı kural). Kart da buna izin veriyor: *"hedef sayfaları daha
 * sonra ... menü bağlantılarını işlevsel içerikle doldurur; Profil menüsü kabuğunun tamamı
 * bunların hepsine koşulsuz hard blocker değildir."* İlgili kart geldiğinde tek satır
 * değişiyor.
 */
export interface ProfileMenuItemDef {
  key: string;
  label: string;
  /** Hedef adres; sayfası henüz yoksa `null`. */
  route: string | null;
}

/**
 * Kart kapsamındaki öğeler, kartın saydığı SIRAYLA. Çıkış Yap burada YOK: o bir bağlantı
 * değil, bir komut — ve menünün en altında ayrı bir bölümde duruyor.
 */
export const PROFILE_MENU_ITEMS: readonly ProfileMenuItemDef[] = [
  /** `[017]` CLOS-65 hesap profilini API tarafında verdi; ekranı henüz yok. */
  { key: "profile", label: "Profilim", route: null },
  /**
   * `[048]` ile AÇILDI: sayfa bugün tek bölüm taşıyor (e-posta değişikliği). 2FA
   * (`[018]`), aktif oturumlar (`[020]`) ve şifre değiştirme (`[021]`) kendi kartlarıyla
   * aynı sayfaya eklenecek.
   */
  { key: "security", label: "Hesap ve Güvenlik", route: "/hesap-ve-guvenlik" },
  /** `[020]` CLOS-68 cihaz uçlarını verdi; oturum listesi ekranı yok. */
  { key: "sessions", label: "Aktif Oturumlar", route: null },
  /**
   * CLOS-843 ile EKLENDİ; karar CLOS-839'da kayıtlı.
   *
   * ⚠ Sayfa aylardır çalışıyordu ama menüde YOKTU: kullanıcı `/onaylarim` adresini elle
   * yazmadan rıza kaydına ulaşamıyordu. Rıza yönetimi hukuki bir yüzey, erişilemez olması
   * KVKK tarafında savunulabilir değil. Kendi adresinde kalıyor ki KVKK talebinde
   * doğrudan referans verilebilsin.
   */
  { key: "consents", label: "Onaylarım", route: "/onaylarim" },
  /** `[146]` CLOS-227 ile AÇILDI: üç davet türünün hesap-seviyesi merkezi. */
  { key: "invitations", label: "Davetlerim", route: "/davetlerim" },
  /** `[066]` CLOS-105 ile açıldı. */
  { key: "preferences", label: "Dil ve Görünüm", route: "/tercihler" },
  /**
   * ⚠ Yardım, Destek ve Geri Bildirim BURADA DEĞİL — CLOS-843 ile ÇIKARILDI.
   *
   * Üçünün de hedefinin hiç kartı yoktu ve `route: null` oldukları için hiç çizilmiyorlardı.
   * Kayıtta durmaları kapsamı olmayan bir sözü kanonik listede tutuyordu: menüde ne olduğu
   * sorulduğunda cevap üç hayalet öğe içeriyordu. İhtiyaç doğduğunda kendi kartıyla geri
   * gelirler (ADR-0014).
   */
];

/**
 * Çizilecek öğeler: yalnız hedefi OLANLAR.
 *
 * Kayıt parametre olarak alınabiliyor — test kendi listesini vererek filtrenin ürünün
 * kodundan geçtiğini doğrulayabilsin diye. Sabit listeyi okusaydı test, kuralı değil
 * bugünkü veriyi ölçerdi.
 */
export function visibleProfileMenuItems(
  items: readonly ProfileMenuItemDef[] = PROFILE_MENU_ITEMS,
): ProfileMenuItemDef[] {
  return items.filter((item) => item.route !== null);
}
